<template>
  <div>
    <div class="mt-4 sm:mt-6 text-center border-t pt-4 sm:pt-6">
      <a href="javascript:void(0)" @click="submitHandler()"
        class="inline-flex justify-center py-2 px-6 border border-transparent shadow-sm text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        Sign in
      </a>
    </div>
  </div>

</template>

<script>
export default {
  props: ["accountNumber", "email"],
  data() {
    return {
      data: {},
      errors: {},
      isProcessing: false,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.data = {
        ...this.data,
        ...{
          email: "",
        },
      };
    },

    checkEmailExists() {
      this.$emit("check-email-exists", this.data.email);
    },

    validateDataForlogin() {
      var errors = {};

      let error = false;

      if (!this.data.email) {
        errors.email = "Please enter E Mail";
        error = true;
      }

      if (!this.data.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
        errors.email = "Please enter valid E Mail";
        error = true;
      }

      this.errors = errors;
      return error;
    },

    submitHandler() {
      this.data.email = this.email;

      if (this.validateDataForlogin()) return;

      this.isProcessing = true;
      const url = `/oauth/popup-login?email=${this.email}&accountNumber=${this.accountNumber}`;
      window.location.href = url;
    },
  },
};
</script>